import { useEffect, useRef } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import { selectTradingAccount } from '../reducers/selectors';
/**
 * A mount-time effect.
 */
export function useReturnIfHasTraded() {
    const navigation = useMainStackNavigation();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingAccountRef = useRef(tradingAccount);
    useEffect(() => {
        const account = tradingAccountRef.current;
        if (account == null) {
            navigation.popToTop();
            return;
        }
        if (account.hasTraded) {
            navigation.popToTop();
            navigation.navigate('InvestPortfolio');
        }
    }, []);
}
